<template>
<div id="email-body" class="email contatto">
      <a :href="evento.website" style="margin:10px 0 0 0;"><img :src="'https://wvpac.mzevents.it/images/'+evento.id+'/head.png'" style="width:380px;border:none;" /></a>   
   <br /><br />

   The abstract of {{contatto.nome }} {{contatto.cognome }} has been reopened for changes! 
   
   <br /><br />
   <div class="row pad yo-text-n" style="">

      <div class="col s7 m3 yo-align-right">IDENTIFICATION NUMBER</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.id}}</div>

      <div class="col s7 m3 yo-align-right">TITLE</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.titolo}} </div>

      <div class="col s7 m3 yo-align-right">LAST MODIFICATION DATE</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.modificatoil | data('DD MMM YYYY')}} </div>

      <div class="col s7 m3 yo-align-right">TOPIC</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.topic | items($evento._topic,'nome')}}</div>

      <div class="col s7 m3 clear yo-align-right">ORAL COMMUNICATION</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.oral | yesno}}</div>
<!--
      <div class="col s7 m3 clear yo-align-right">BEST POSTER AWARD</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.bestposterawards | yesno}}</div>

      <div class="col s7 m3 clear yo-align-right">FLASH POSTER PRESENTATION</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.flashposterpresentation | yesno}}</div>
-->
      <div class="col s7 m3 yo-align-right">KEYWORDS</div>
      <div class="col s5 m9 yo-text-bold">{{abstract.parolechiave}}</div>

      <div class="col s7 m3 yo-align-right">PREVIEW</div>
      <div class="col s5 m9 yo-text-bold"><a :href="abstract.preview">Download PDF</a></div>

   </div>
   <br /><br />

         

</div>
</template>

<script>
export default {
   props: ['contatto','evento','abstract']
}
</script>
